namespace GeniuzPOS.PosShift {
    export namespace PsPosMoneyCountService {
        export const baseUrl = 'PosShift/PsPosMoneyCount';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsPosMoneyCountRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsPosMoneyCountRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "PosShift/PsPosMoneyCount/Retrieve",
            List = "PosShift/PsPosMoneyCount/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsPosMoneyCountService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
